import(/* webpackMode: "eager" */ "/opt/build/repo/app/gallery/page.tsx")